import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import PublishIcon from '@material-ui/icons/Publish';
import { toast } from 'react-toastify';
import { ModalActionsComponent, PasslyButton } from '@app/components';
import { onPressEnterModal } from '@app/helpers';
import { getModalSwitch, getLoaderBtn, setExceptionHandler } from '@app/store/actions';
import { workflowRequestService } from '@app/services';

export interface IReceivedData {
    handleRefresh: Function;
}

const UploadWorkflowDialog = (props: IReceivedData) => {
    const dispatch = useDispatch();

    const { translation } = useTypedTranslation();

    const [selectedFileName, setSelectedFileName] = useState('');
    const [inputFile, setInputFile] = useState<object>({});
    const [buttonState, setButtonState] = useState(true);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    // -------------------------------------------
    // ----------------- EFFECTS -----------------
    // -------------------------------------------
    useEffect(() => {
        dispatch(setExceptionHandler(true));
    }, []);

    const handleInputValue = (e: any) => {
        if (e.target.files.length) {
            const formData = new FormData();
            formData.append('file', e.target.files[0]);

            const isValid: boolean = isValidFile(e.target.files[0].name);

            if (isValid) {
                setErrorMessage(undefined);
                setInputFile(formData);
                setSelectedFileName(e.target.files[0].name);
                setButtonState(false);
            }
            else {
                setButtonState(true);
                setErrorMessage(translation('NO_VALID_SAMLX'));
            }
        } else {
            return;
        }
    };

    const handleError = (error: any) => {
        setErrorMessage(translation('SAMLX_REQUEST_FAILED_BODY'));
        dispatch(getLoaderBtn(false));
    };

    const handleCancel = () => {
        dispatch(getModalSwitch(false));
    };

    const handleSuccess = () => {
        dispatch(getLoaderBtn(false));
        dispatch(getModalSwitch(false));
        toast(translation('SAMLX_REQUEST_SUBMITTED_BODY'));
        props.handleRefresh(true);
    };

    const isValidFile = (fileName: string) => {
        // make sure file is a samlx file
        const extension: string = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

        if (extension !== 'samlx') {
            return false;
        }

        return true;
    };

    const handleUploadBtn = () => {
        workflowRequestService.uploadWorkflowRequest(inputFile, handleError, handleSuccess);
        dispatch(getLoaderBtn(true));
    };

    return (
        <>
        <div className='modal__form' tabIndex={0} onKeyPress={onPressEnterModal(handleUploadBtn, buttonState)}>
            <div className='modal__large flex1'>
                <div className='modal__body--row'>
                    <p>{translation('SAMLX_SUBMISSION_DESCRIPTION')}</p>
                    <input
                        onChange={handleInputValue}
                        style={{ display: 'none' }}
                        id='users-import-btn'
                        multiple
                        type='file'
                    />
                    <label htmlFor='users-import-btn'>
                        <PasslyButton
                            variant='contained'
                            color='primary'
                            className='modal__form-btn'
                            component='span'
                            startIcon={<PublishIcon />}
                        >
                            {translation('SAMLX_BUTTON')}
                        </PasslyButton>
                    </label>
                    <h5><span>{translation('IMPORT_FILE_HEADER')}</span> <span className='modal__form-subheader'>{selectedFileName}</span></h5>
                </div>
            </div>
            {
                errorMessage &&
                <div className='modal__error'>{errorMessage}</div>
            }
        </div>
        <ModalActionsComponent
            primaryBtn={translation('SAMLX_SUBMISSION_DESCRIPTION_SUBMISSION_SUBMIT')}
            secondaryBtn={translation('CANCEL')}
            onClickPrimary={handleUploadBtn}
            onClickSecondary={handleCancel}
            disabled={buttonState}
            id='uploadWorkflow'
        />
        </>
    );
};

export default UploadWorkflowDialog;
